var _path;
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
const SvgYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12 6c5 0 6.53.063 7.22.781.51.532.78 2.13.78 5.219s-.27 4.688-.78 5.219c-.69.718-2.225.781-7.22.781s-6.53-.062-7.22-.781C4.27 16.687 4 15.089 4 12s.27-4.687.78-5.219C5.47 6.063 7 6 12 6m-1.5 3.5v5a.25.25 0 0 0 .4.2l3.333-2.5a.25.25 0 0 0 0-.4L10.9 9.3a.25.25 0 0 0-.4.2"
})));
export default SvgYoutube;